import React from "react"
import styled from "styled-components"

import { CardPropsType } from "./Card.types"

import { styleTheme } from "../../../style/theme";

export const Card: React.FC<CardPropsType> = (props) => {
  return (
    <StyledComponent
      {...props}
      theme={styleTheme}
    />
  )
}

type ComponentProps = CardPropsType & {
  className?: string
}

const Component: React.FC<ComponentProps> = (props) => (
  <div className={props.className}>
    <div className={`${props.className}__heading`} data-align={props.align} data-color={props.color}>{props.title}</div>
    <div className={`${props.className}__body`} data-color={props.color}>
      {props.children}
    </div>
  </div>
)

const StyledComponent = styled(Component)`
  background: ${props => props.theme.colors.white};
  border-radius: 8px;
  width: 100%;

  &__heading {
    border-radius: 8px 8px 0 0;
    font-size: 18px;
    font-weight: bold;
    padding: 16px 32px;

    &[data-color="teal"] {
      background: ${props => props.primaryColor};
      color: ${props => props.theme.colors.white};
    }

    &[data-color="gray"] {
      background: ${props => props.theme.colors.gray.base};
      color: ${props => props.theme.colors.black};
    }

    &[data-align="left"] {
      text-align: left;
    }

    &[data-align="center"] {
      text-align: center;
    }

    &[data-align="right"] {
      text-align: right;
    }
  }

  &__body {
    padding: ${props => props.compact ? '0;' : '32px 64px;'};
    border: solid 1px;
    border-radius: 0 0 8px 8px;

    &[data-color="teal"] {
      border-color: ${props => props.primaryColor};
    }

    &[data-color="gray"] {
      border-color: ${props => props.theme.colors.gray.base};
    }
  }
`